import React from 'react';
import AbstractChart from './AbstractChart';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import noData from 'highcharts/modules/no-data-to-display';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import moment from 'moment';

import {
  DEFAULT_IS_DISPLAY_LABEL,
  CUSTOM_ELEMENT_IN_CHART_ATTR,
  NORMAL_LABEL_FONT_SIZE,
  CHANGE_LABEL_Z_INDEX_FUNCTION_NAME,
  CHART_HEIGHT_WHEN_NOT_DISPLAY_LABEL,
  CHART_HEIGHT_WHEN_DISPLAY_LABEL,
  CHART_MARGIN_BOTTOM_WHEN_DISPLAY_LABEL,
  CHART_MARGIN_LEFT_WHEN_DISPLAY_LABELS,
  CHART_MARGIN_BOTTOM_WHEN_NOT_DISPLAY_LABEL,
  CHART_MARGIN_LEFT_WHEN_NOT_DISPLAY_LABELS,
  CHART_MARGIN_RIGHT_WHEN_DISPLAY_LABELS,
  CHART_MARGIN_RIGHT_WHEN_NOT_DISPLAY_LABELS,
  CHART_BACKGROUND_COLOR,
  EVENT_LABEL_WRAPPER_CLASS_NAME,
  HIGHCHART_ANNOTATION_LABEL_BOX_CLASS,
  BUTTON_EDIT_LABEL_CLASSNAME,
  BUTTON_DELETE_LABEL_CLASSNAME,
  MARKER_LINE,
  TIME_CONSTANT,
  AXIS_POINT_LIMIT,
  MAX_DAYS_FOR_TIME_CONSTANT_1_TICK_LABELS,
  MIN_DAYS_FOR_TIME_CONSTANT_7_TICK_LABELS,
  MAX_DAYS_FOR_TIME_CONSTANT_7_TICK_LABELS,
  MIN_DAYS_FOR_TIME_CONSTANT_14_TICK_LABELS,
  MAX_DAYS_FOR_TIME_CONSTANT_14_TICK_LABELS,
  MIN_DAYS_FOR_TIME_CONSTANT_90_TICK_LABELS,
  MAX_DAYS_FOR_TIME_CONSTANT_90_TICK_LABELS,
  DATE_TIME_IN_YYYY_MM_DD_FORMAT,
  LABEL_SIZE_TEXT_PADDING_RIGHT,
  DEFAULT_CUSTOM_LABELS_TRANSLATE_Y,
  SMALL_LABEL_FONT_SIZE,
  LARGE_LABEL_FONT_SIZE,
  BUTTON_SET_FONT_SIZE_SMALL_PADDING_FROM_THE_LABEL_SIZES_TEXT,
  BUTTON_SET_FONT_SIZE_MEDIUM_PADDING_FROM_THE_LABEL_SIZES_TEXT,
  BUTTON_SET_FONT_SIZE_LARGE_PADDING_FROM_THE_LABEL_SIZES_TEXT,
  BUTTON_SET_FONT_SIZE_SMALL_ADJUST_CUSTOM_TRANSLATE_Y,
  BUTTON_SET_FONT_SIZE_MEDIUM_ADJUST_CUSTOM_TRANSLATE_Y,
  BUTTON_SET_FONT_SIZE_LARGE_ADJUST_CUSTOM_TRANSLATE_Y,
  LABEL_SIZE_DISPLAY_TEXT,
  SHOW_LABELS_BUTTON_TEXT,
  SHOW_LABEL_TEXT_PADDING_RIGHT,
  CHECKBOX_SHOW_HIDE_LABELS_PADDING_RIGHT,
  CHECKBOX_SHOW_HIDE_LABELS_PADDING_TOP,
  CHECKBOX_SHOW_HIDE_LABELS_SIZE,
  DEFAULT_TOOLTIP,
  ADD_LABEL_POPUP_WRAPPER_CLASS_NAME,
  ADD_LABEL_POPUP_CONTENT_CLASS,
  ADD_LABEL_INPUT_ACTIONS_WRAPPER_CLASS_NAME,
  BUTTON_CANCEL_ADD_LABEL_CLASS_NAME,
  BUTTON_SAVE_LABEL_CLASS_NAME,
  LABEL_INPUT_CLASS_NAME,
  LABEL_INPUT_MAX_LENGTH,
  DATE_TIME_IN_YYYY_MM_DD_HH_MM_SS_FORMAT,
  POPUP_ADD_EVENT_LABEL_MARGIN_TOP,
  POPUP_ADD_EVENT_LABEL_MARGIN_LEFT,
  X_AXIS_LABEL_CUSTOM_TOOLTIP_STYLE,
  ADD_EVENT_LABEL_TEXT,
  EDIT_EVENT_LABEL_TEXT,
  DELETE_EVENT_LABEL_BOX_BACKGROUND_COLOR,
  BUTTON_CANCEL_DELETE_BACKGROUND_COLOR,
  LABEL_TEXT_CLASS,
  DELETE_ACTION_CONFIRM_CLASS,
  BUTTON_YES_DELETE_CLASS,
  BUTTON_CANCEL_DELETE_CLASS,
  SPLINE_CHART,
  DATA_KEY,
  TOTAL_TREND_INDEX,
  POSITIVE_TREND_INDEX,
  NEGATIVE_TREND_INDEX,
  NEUTRAL_TREND_INDEX,
  DATE_KEY_INDEX,
  COUNT_INDEX,
  JOY_TREND_INDEX,
  FEAR_TREND_INDEX,
  SADNESS_TREND_INDEX,
  ANGER_TREND_INDEX,
  PERCENTAGE_TREND_CHART_Y_AXIS_INTERVAL,
  PERCENTAGE_TREND_CHART_MAXIMUM_Y_AXIS_VALUE
} from './constants/eventLabellingChartConstants';
import checkedCheckboxIcon from '../../../img/checkbox_checked.svg';
import uncheckedCheckboxIcon from '../../../img/checkbox_unchecked.svg';
import { getYAxisTickInterval } from './HighChartUtils';
import { 
  DEFAULT_HIGH_CHART_MAP_OPTIONS, 
  MAP_OPTIONS, 
  PERCENTAGE_TREND_CHART_MAP_OPTIONS,
  SERIES_KEY
 } from './constants/HighchartsConstants';
import { SENTIMENT_PERCENTAGE_TREND_CHART_ID, EMOTION_PERCENTAGE_TREND_CHART_ID } from './redux/constants';
import { calculateCategoryPercentageRoundedToOneDecimalPlace } from './CommonChartMethods'

require("highcharts/modules/annotations")(Highcharts);
noData(Highcharts);
const bspline = require('b-spline');


class EventLabellingChart extends AbstractChart {
  constructor(props) {
    super(props);
    this.textAreaLabelRef = React.createRef();
    this.handleTextAreaChange = this.handleTextAreaChange.bind(this);
    const that = this;
    this.state = {
      isCommentsActive: null,
      chartData: [],
      labelsData: [],
      hideSeries: [],
      annotations: [],
      addLabelPopupId: 'addLabelPopup' + props.chartId,
      addLabelPopupWrapperId: 'wrapperAddLabelPopup' + props.chartId,
      showEditLabelFunctionName: 'showEditLabel' + props.chartId,
      showDeleteViewFunctionName: 'showDeleteView' + props.chartId,
      labelViewIdPrefix: props.chartId + 'lables-wrapper',
      buttonNoDeleteLabelIdPrefix: props.chartId + 'no-delete-label',
      buttonDeleteLabelFunction: props.chartId + 'deleteLabel',
      changeLabelZIndexFunctionName: props.chartId + CHANGE_LABEL_Z_INDEX_FUNCTION_NAME,
      eventLabelWrapperClassNameForChart: EVENT_LABEL_WRAPPER_CLASS_NAME + props.chartId,
      isDisplayLabels: DEFAULT_IS_DISPLAY_LABEL,
      customElementsInChartAttr: CUSTOM_ELEMENT_IN_CHART_ATTR + props.chartId,
      labelsFontSize: NORMAL_LABEL_FONT_SIZE,
      selectedDay: "",
      textAreaValue: "",
      source: [],
      topicId: null,
      tickInterval: [],
      mapDataFromProps: {},
      mapLabelsFromProps: {},
      filterDateRange: {
        fromDate: moment().format(DATE_TIME_IN_YYYY_MM_DD_FORMAT),
        toDate: moment().format(DATE_TIME_IN_YYYY_MM_DD_FORMAT),
      },
      mapOptions: {
        ...JSON.parse(JSON.stringify(this.getMapOptionsBasedOnChartId(props.chartId))),
        chart: {
          type: props.chartType,
          backgroundColor: CHART_BACKGROUND_COLOR,
          ...this.getChartSizeWhenNotDisplayEventLabels(),
          events: {
            redraw: function () {
              that.renderCustomLabelsAndButtons();
            },
            render: function () {
              that.makeConnectorFromDataPointToLabelVertical();
              that._callFunctionMakeConnectorVerticalAgainAfter1SecondToMakeSureAllConnectorsAreVertical();
            }
          }
        },
        plotOptions: {
          series: {
            events: {
              legendItemClick: function (e) {
                const hideSeries = that.getHiddenSerises(e);
                const annotations = that.generateAnnotation(that.state.chartData.chart, that.state.labelsData, hideSeries);
                that.setState(prevState => {
                  return {
                    ...prevState,
                    hideSeries,
                    annotations,
                    mapOptions: {
                      ...prevState.mapOptions,
                      annotations
                    }
                  };
                }, () => {
                  if (that.state.isDisplayLabels) {
                    that.showAllLabels();
                  };
                })
              }
            },
            marker: {
              enabled: true,
            },
            point: {
              events: {
                click: function () {
                  that.filterCommentsAndFeeds({
                    sentiment: props.getSentiment(this.series.name),
                    dateTime: moment.utc(this.category).format(DATE_TIME_IN_YYYY_MM_DD_FORMAT),
                  });
                },
              },
            },
            cursor: 'pointer',
          },
        },
      },
    };

    this.chartComponent = React.createRef();
    this.buttonCheckedRef = null;
    this.buttonUnCheckedRef = null;
  }

  _callFunctionMakeConnectorVerticalAgainAfter1SecondToMakeSureAllConnectorsAreVertical() {
    setTimeout(() => {
      this.makeConnectorFromDataPointToLabelVertical();
    },1000);
  }

  getMapOptionsBasedOnChartId(chartId) {
    if (this.isPercentageTrendChart(chartId)) {
      return PERCENTAGE_TREND_CHART_MAP_OPTIONS;
    }
    else {
      return DEFAULT_HIGH_CHART_MAP_OPTIONS;
    }
  }

  isPercentageTrendChart(chartId) {
    return (chartId === SENTIMENT_PERCENTAGE_TREND_CHART_ID || chartId === EMOTION_PERCENTAGE_TREND_CHART_ID);
  }
  
  removeOldLabelsAndButtons() {
    const customItems = document.querySelectorAll(`[${this.state.customElementsInChartAttr}]`);
    for (const item of customItems) {
      item.remove();
    }
  }

  renderCustomLabelsAndButtons() {
    this.removeOldLabelsAndButtons();
    this.renderLabelsSizeController();
    this.renderLabelsCheckboxController();
  }

  renderLabelsCheckboxController() {
    this.renderShowLabelsText();
    if (this.state.isDisplayLabels) {
      this.showButtonChecked();
    }
    else {
      this.showButtonUnChecked();
    }
  }

  generateButtonCheckbox(icon) {
    const chart = this.chartComponent.current.chart;
    const chartWidth = chart.containerWidth;
    const customAtrr = {};
    customAtrr[this.state.customElementsInChartAttr] = this.state.customElementsInChartAttr;
    return chart.renderer
      .image(
        icon,
        chartWidth - CHECKBOX_SHOW_HIDE_LABELS_PADDING_RIGHT,
        CHECKBOX_SHOW_HIDE_LABELS_PADDING_TOP,
        CHECKBOX_SHOW_HIDE_LABELS_SIZE,
        CHECKBOX_SHOW_HIDE_LABELS_SIZE
      )
      .attr(customAtrr);
  }

  showButtonChecked() {
    const refThis = this;
    this.buttonCheckedRef =
      this.generateButtonCheckbox(checkedCheckboxIcon)
        .on('click', function () {
          refThis.handleToHideAllEventsLabels();
        })
        .add();
  }

  hideAllLabelsSeries() {
    for (const item of this.chartComponent.current.chart.series) {
      if (item.name === "") item.hide();
    }
  }

  setHighChartToDisplayNoLabels() {
    this.chartComponent.current.chart.update({
      annotations: [],
      chart: this.getChartSizeWhenNotDisplayEventLabels(),
    });
  }

  hideAllLabels() {
    this.setState({
      isDisplayLabels: false
    });
    this.hideAllLabelsSeries();
    this.setHighChartToDisplayNoLabels();
    this.setState(prevState => {
      return {
        ...prevState,
        mapOptions: {
          ...prevState.mapOptions,
          annotations: [],
        },
      };
    });
  }


  handleToHideAllEventsLabels() {
    this.hideAllLabels();
    this.showButtonUnChecked();
    this.destroyItem(this.buttonCheckedRef);
  }

  handleToShowAllEventsLabels() {
    this.showAllLabels();
    this.showButtonChecked();
    this.destroyItem(this.buttonUnCheckedRef);
  }

  destroyItem(item) {
    try {
      item.destroy();
    } catch (err) {
      item = null;
    }
  }


  showButtonUnChecked() {
    const refThis = this;
    this.buttonUnCheckedRef =
      this.generateButtonCheckbox(uncheckedCheckboxIcon)
        .on('click', function () {
          refThis.handleToShowAllEventsLabels();
        })
        .add();
  }

  renderShowLabelsText() {
    this.renderCustomLabel(SHOW_LABELS_BUTTON_TEXT, SHOW_LABEL_TEXT_PADDING_RIGHT, DEFAULT_CUSTOM_LABELS_TRANSLATE_Y, {});
  }

  renderButtonSetLabelsToSmallFontSize() {
    this.renderButtonsChangeFontSize(SMALL_LABEL_FONT_SIZE, BUTTON_SET_FONT_SIZE_SMALL_PADDING_FROM_THE_LABEL_SIZES_TEXT, BUTTON_SET_FONT_SIZE_SMALL_ADJUST_CUSTOM_TRANSLATE_Y);
  }

  renderButtonSetLabelsToMediumFontSize() {
    this.renderButtonsChangeFontSize(NORMAL_LABEL_FONT_SIZE, BUTTON_SET_FONT_SIZE_MEDIUM_PADDING_FROM_THE_LABEL_SIZES_TEXT, BUTTON_SET_FONT_SIZE_MEDIUM_ADJUST_CUSTOM_TRANSLATE_Y);
  }

  renderButtonSetLabelsToLargeFontSize() {
    this.renderButtonsChangeFontSize(LARGE_LABEL_FONT_SIZE, BUTTON_SET_FONT_SIZE_LARGE_PADDING_FROM_THE_LABEL_SIZES_TEXT, BUTTON_SET_FONT_SIZE_LARGE_ADJUST_CUSTOM_TRANSLATE_Y);
  }

  renderButtonsChangeFontSize(fontSize, paddingFromRight, paddingFromTop) {
    const opacity = this.getLabelOpacityBasedOnCurrentState(fontSize);
    const button = this.renderCustomLabel('A', LABEL_SIZE_TEXT_PADDING_RIGHT - paddingFromRight, DEFAULT_CUSTOM_LABELS_TRANSLATE_Y + paddingFromTop, {
      fontSize: `${fontSize}px`,
      color: '#2699FB',
      opacity: opacity,
      cursor: 'pointer'
    });
    this.setFunctionChangeFontSizeForButton(button, fontSize);
  }

  setFunctionChangeFontSizeForButton(button, fontSize) {
    const componentThis = this;
    button.on('click', function () {
      componentThis.changeLabelsFontSize(fontSize);
    });
  }

  changeLabelsFontSize(fontSize) {
    if (this.state.labelsFontSize !== fontSize) {
      const annotationsWithNewFontSize = this.updateFontSizeForLabels(fontSize);
      this.setState({
        labelsFontSize: fontSize,
        annotations: annotationsWithNewFontSize,
      }, () => {
        this.renderCustomLabelsAndButtons();
        this.updateLabelsFontSizeOnGraph();
        this.updateChartHeightAndMarginBottom();
      });
    }
  }

  updateLabelsFontSizeOnGraph() {
    if (this.state.isDisplayLabels) {
      this.showAllLabels();
    }
  }


  updateFontSizeForLabels(fontSize) {
    return this.state.annotations.map(item => {
      return {
        ...item,
        labelOptions: {
          ...item.labelOptions,
          style: {
            fontSize: `${fontSize}px`
          }
        }
      }
    });
  }

  getLabelOpacityBasedOnCurrentState(fontSize) {
    return this.state.labelsFontSize === fontSize ? 1 : 0.3;
  }

  renderLabelsSizeController() {
    this.renderCustomLabel(LABEL_SIZE_DISPLAY_TEXT, LABEL_SIZE_TEXT_PADDING_RIGHT, DEFAULT_CUSTOM_LABELS_TRANSLATE_Y, {});
    this.renderButtonSetLabelsToSmallFontSize();
    this.renderButtonSetLabelsToMediumFontSize();
    this.renderButtonSetLabelsToLargeFontSize();
  }

  renderCustomLabel(text, paddingFromRight, translateY, customStyles) {
    const chart = this.chartComponent.current.chart;
    const chartWidth = chart.containerWidth;
    const customAtrr = {};
    customAtrr[this.state.customElementsInChartAttr] = this.state.customElementsInChartAttr;
    return chart.renderer.label(text, chartWidth - paddingFromRight, translateY)
      .css({
        fontSize: '10px',
        color: '#999999',
        ...customStyles
      })
      .attr(customAtrr)
      .add();
  }

  getHiddenSerises(e) {
    if(e.target.visible){
      return [...this.state.hideSeries, e.target.name];
    }
    else if(this.state.hideSeries){
      return this.state.hideSeries.filter(item => item !== e.target.name);
    }
    return [];
  }

  getLabelsToDisplayInChart(chart, labelData) {
    const dateMin = chart[0].data[0][0];
    const dateMax = chart[0].data[chart[0].data.length - 1][0];
    return labelData.filter((item) => {
      return item.x >= dateMin && item.x <= dateMax && item.topicId === this.props.selectedTopicId[0];
    });
  }

  getChartSizeWhenNotDisplayEventLabels() {
    return {
      height: CHART_HEIGHT_WHEN_NOT_DISPLAY_LABEL,
      marginBottom: CHART_MARGIN_BOTTOM_WHEN_NOT_DISPLAY_LABEL,
      marginLeft: CHART_MARGIN_LEFT_WHEN_NOT_DISPLAY_LABELS,
      marginRight: CHART_MARGIN_RIGHT_WHEN_NOT_DISPLAY_LABELS
    };
  }

  getChartSizeWhenDisplayingLabels() {
    return {
      height: CHART_HEIGHT_WHEN_DISPLAY_LABEL,
      marginBottom: CHART_MARGIN_BOTTOM_WHEN_DISPLAY_LABEL,
      marginLeft: CHART_MARGIN_LEFT_WHEN_DISPLAY_LABELS,
      marginRight: CHART_MARGIN_RIGHT_WHEN_DISPLAY_LABELS
    };
  }

  areNoLabelsToDisplay(annotations) {
    return annotations && annotations.length === 0;
  }

  getChartSize(annotations) {
    return this.areNoLabelsToDisplay(annotations) ? this.getChartSizeWhenNotDisplayEventLabels() : this.getChartSizeWhenDisplayingLabels();
  }

  showAllLabels() {
    this.setState({ isDisplayLabels: true });
    const { chartData, labelsData, hideSeries } = this.state;
    for (const item of this.chartComponent.current.chart.series) {
      if (item.name === "") item.show();
    }
    const annotations = this.generateAnnotation(chartData.chart, labelsData, hideSeries);
    this.chartComponent.current.chart.update({
      annotations: annotations,
      chart: this.getChartSize(annotations)
    });
    this.setState(prevState => {
      return {
        ...prevState,
        mapOptions: {
          ...prevState.mapOptions,
          annotations: annotations,
        },
      };
    });
  }

  
  updateChartHeightAndMarginBottom() {
    setTimeout(() => {
      let labelBox = document.getElementsByClassName(this.state.eventLabelWrapperClassNameForChart);
      let arrHeight = [];
      if (labelBox.length !== 0) {
        for (const label of labelBox) {
          arrHeight.push(label.offsetHeight);
        }
        const maxHeight = Math.max(...arrHeight);
        this.chartComponent.current.chart.update({
          chart: {
            height: CHART_HEIGHT_WHEN_DISPLAY_LABEL + maxHeight,
            marginBottom: CHART_MARGIN_BOTTOM_WHEN_DISPLAY_LABEL + maxHeight,
            marginLeft: CHART_MARGIN_LEFT_WHEN_DISPLAY_LABELS,
            marginRight: CHART_MARGIN_RIGHT_WHEN_DISPLAY_LABELS
          }
        });
      } else {
        if (this.chartComponent.current) {
          this.chartComponent.current.chart.update({
            chart: this.getChartSizeWhenNotDisplayEventLabels(),
          });
        }
      }
    }, 5);
  }

  makeConnectorFromDataPointToLabelVertical() {
    const dash = document.getElementsByClassName(HIGHCHART_ANNOTATION_LABEL_BOX_CLASS);
    if (dash.length) {
      let dAttribute = dash[0].getAttribute('d');
      let regex = /[+-]?\d+(\.\d+)?/g;
      let matches = dAttribute.match(regex);
      const newDAttribute = `M ${matches[0]} ${matches[1]} L ${matches[0]} ${matches[3]}`;
      for (const dashItem of dash) {
        dashItem.setAttribute("d", newDAttribute);
      }
    }
  }

  filterCommentsAndFeeds = (props = {}) => {
    this.props.filterBySentiments(props);
  };


  getTickInterval = dateTime => {
    const startDate = moment(dateTime.fromDate);
    const endDate = moment(dateTime.toDate);
    const diffDays = endDate.diff(startDate, 'days');
    if (diffDays === 0) {
      return TIME_CONSTANT / 4;
    } else if (diffDays < MAX_DAYS_FOR_TIME_CONSTANT_1_TICK_LABELS) {
      return TIME_CONSTANT;
    } else if (diffDays > MIN_DAYS_FOR_TIME_CONSTANT_7_TICK_LABELS  && diffDays < MAX_DAYS_FOR_TIME_CONSTANT_7_TICK_LABELS) {
      return TIME_CONSTANT * 7;
    } else if (diffDays > MIN_DAYS_FOR_TIME_CONSTANT_14_TICK_LABELS && diffDays < MAX_DAYS_FOR_TIME_CONSTANT_14_TICK_LABELS) {
      return TIME_CONSTANT * 14;
    } else if (diffDays > MIN_DAYS_FOR_TIME_CONSTANT_90_TICK_LABELS && diffDays < MAX_DAYS_FOR_TIME_CONSTANT_90_TICK_LABELS) {
      return TIME_CONSTANT * 90;
    } else {
      return TIME_CONSTANT * 180;
    }
  };

  reRenderChartOnChange = props => {
    let { mapOptions } = this.state;
    mapOptions['xAxis']['tickInterval'] = this.getTickInterval(props.dateRangeFilterValue);
    this.setState({ mapOptions });
    const { retrieveSelectedChartData, retrieveLabelsForChart } = this.props.actions;
    this.setState(
      {
        filterDateRange: props.dateRangeFilterValue,
        topicId: props.selectedTopicId,
        source: props.source,
      },
      () => {
        retrieveLabelsForChart({
          chartId: this.props.chartId,
          dateFilterValue: this.state.filterDateRange,
          topicId: this.state.topicId,
        });
        retrieveSelectedChartData({
          chartId: this.props.chartId.replace('chart', ''),
          dateFilterValue: this.state.filterDateRange,
          topicId: this.state.topicId,
          source: this.state.source,
        });
      },
    );
  };

  componentDidMount() {
    Highcharts.seriesTypes.line.prototype.drawLegendSymbol =
      Highcharts.seriesTypes.column.prototype.drawLegendSymbol;
    this.reRenderChartOnChange(this.props);
    this._reflowChartAfterDelays();
    this.addFunctionsToWindowToHandleClickingOnButtonsOnLabels();
  }

  addFunctionsToWindowToHandleClickingOnButtonsOnLabels() {
    this.addFunctionChangeLabelZIndexToWindow();
    this.addFunctionShowPopupEditEventLabelToWindow();
    this.addFunctionShowDeleteViewToWindow();
    this.addFunctionButtonDeleteLabelToWindow();
  }

  addFunctionShowDeleteViewToWindow() {
    const that = this;
    window[this.state.showDeleteViewFunctionName] = function (event, timeStampOfLabel) {
      that.stopSendClickEventToParentsNode(event);
      let labelBox = document.getElementById(that.state.labelViewIdPrefix + timeStampOfLabel);
      const currentInner = labelBox.innerHTML;
      labelBox.style.backgroundColor = DELETE_EVENT_LABEL_BOX_BACKGROUND_COLOR;
      labelBox.innerHTML = that.generateHTMLOfDeleteBox(timeStampOfLabel);
      const buttonCancel = document.getElementById(`${that.state.buttonNoDeleteLabelIdPrefix}${timeStampOfLabel}`);
      buttonCancel.onclick = function () {
        labelBox.innerHTML = currentInner;
        labelBox.style.backgroundColor = BUTTON_CANCEL_DELETE_BACKGROUND_COLOR;
      }
    }
  }

  stopSendClickEventToParentsNode(event) {
    event.stopPropagation();
  }

  generateHTMLOfDeleteBox(timeStampOfLabel) {
    return `
    <p class='${LABEL_TEXT_CLASS}'>Are you sure you want to permanently delete this label?</p>
    <div class='${DELETE_ACTION_CONFIRM_CLASS}'>
    <p class='${BUTTON_YES_DELETE_CLASS}' onclick="${this.state.buttonDeleteLabelFunction}(${timeStampOfLabel})">Yes, Delete</p>
    <p class='${BUTTON_CANCEL_DELETE_CLASS}' id="${this.state.buttonNoDeleteLabelIdPrefix}${timeStampOfLabel}">No</p>
    </div>`;
  }

  addFunctionButtonDeleteLabelToWindow() {
    const that = this;
    window[this.state.buttonDeleteLabelFunction] = function (timeStampOfLabel) {
      const labelToDelete = that.state.labelsData.find(label => label.x === timeStampOfLabel);
      if(labelToDelete) {
        if(labelToDelete.x === that.state.selectedDay) {
          that.hideAddEventLabelPopup();
        }
        that.props.actions.deleteEventLabel({
          id: labelToDelete.id,
          chartId: that.props.chartId
        });
      }
    }
  }

  addFunctionShowPopupEditEventLabelToWindow() {
    const that = this;
    window[this.state.showEditLabelFunctionName] = function (timeStampOfLabel, plotX, plotY, plotLeft, plotTop) {
      that.showInputPopup(timeStampOfLabel, plotX, plotY, plotLeft, plotTop);
    }
  }

  addFunctionChangeLabelZIndexToWindow() {
    const that = this;
    window[this.state.changeLabelZIndexFunctionName] = function (x) {
      let { annotations } = that.chartComponent.current.chart;
      const currentAnnotation = annotations.find(item => item.userOptions.id === x);
      currentAnnotation && currentAnnotation.update({ zIndex: 10 });
      that.makeConnectorFromDataPointToLabelVertical();
    }
  }

  hasReceiveFullDataToParseChart(nextProps, chartId) {
    return JSON.stringify(nextProps.Charts[chartId]) !==
    JSON.stringify(this.state.mapDataFromProps)
    && this.isReceivedLabelsData(nextProps, chartId)
    && nextProps.selectedTopicId.length;
  }

  isReceivedLabelsData(nextProps,chartId) {
    return nextProps.Labels[chartId];
  }

  initDataForChartAndLabels() {
    this.setState({ chartData: [], labelsData: [] });
  }

  shouldDisplayLabels(chartData) {
    const firstSeries = chartData.chart[0];
    return firstSeries && this.state.isDisplayLabels;
  }


  UNSAFE_componentWillReceiveProps(nextProps) {
    const { chartId, title, source } = this.props;
    if (
      this.hasReceiveFullDataToParseChart(nextProps, chartId)
    ) {
      this.updateChartInformationFromNewProps(nextProps, chartId, title, source);
    } 

    if(this.isLabelUpdated(nextProps, chartId)) {
      this.updateLabelsOnUI(nextProps);
    }

    if (this._shouldReRenderChartBasedOnNewProps(nextProps)) {
      this.reRenderChartOnChange(nextProps);
    }

    this._reflowChartIfCommentsSidebarHasOpenedOrClosed(nextProps);
  }

  isLabelUpdated(nextProps, chartId) {
    return nextProps.Labels[this.props.chartId] && this.isReceivedDataChartData() && (JSON.stringify(nextProps.Labels[chartId]) !== JSON.stringify(this.state.mapLabelsFromProps));
  }

  isReceivedDataChartData() {
    const dataInString = JSON.stringify(this.state.mapDataFromProps);
    return dataInString !== '{}' && dataInString !== '[]';
  }

  updateChartInformationFromNewProps(nextProps, chartId, title, source) {
    this.initDataForChartAndLabels();
    const chartData = this.props.parseChartData(
      this.updateChartDataToRequiredFormatsIfNeeded(nextProps, chartId),
    );
    this.addALineAtXAxis(chartData.chart);
    const labelsData = this.convertDateTimeFormatInLabels(nextProps.Labels[chartId]);
    let annotations = [];
    if (this.shouldDisplayLabels(chartData)) {
      annotations = this.generateAnnotation(chartData.chart, labelsData, this.state.hideSeries);
    }
    const mapOptions = this.addInformationToChart(annotations, chartData, title, chartId);
    this.setChartNewInfomationToState(chartData, mapOptions, source, annotations, labelsData, chartId);
  }

  updateChartDataToRequiredFormatsIfNeeded(nextProps, chartId) {
    let chartData = JSON.parse(JSON.stringify(nextProps.Charts[chartId]));
    if (!this.isPercentageTrendChart(chartId) || chartData.length === 0) {
      return chartData;
    }
    if (chartId === SENTIMENT_PERCENTAGE_TREND_CHART_ID) {
      chartData = this.changeChartDataToPercentageForSentimentPercentageTrendCharts(chartData);
    }
    else if (chartId === EMOTION_PERCENTAGE_TREND_CHART_ID) {
      chartData = this.changeChartDataToPercentageForEmotionPercentageTrendCharts(chartData);
    }
    return chartData;
  }
  
  changeChartDataToPercentageForSentimentPercentageTrendCharts(chartData) {

    let totalPercentagesData = [];
    let positivePercentagesData = [];
    let negativePercentagesData = [];
    let neutralPercentagesData = [];

    let totalCountsData = chartData[TOTAL_TREND_INDEX][DATA_KEY];
    let positiveCountsData = chartData[POSITIVE_TREND_INDEX][DATA_KEY];
    let negativeCountsData = chartData[NEGATIVE_TREND_INDEX][DATA_KEY];
    let neutralCountsData = chartData[NEUTRAL_TREND_INDEX][DATA_KEY];

    for (let i = 0; i < totalCountsData.length; i++) {
      let dateKey = totalCountsData[i][DATE_KEY_INDEX];
      let totalCount = totalCountsData[i][COUNT_INDEX];
      totalPercentagesData.push([dateKey, 100]);
      
      if (totalCount === 0) {
        positivePercentagesData.push([dateKey, 0]);
        negativePercentagesData.push([dateKey, 0]);
        neutralPercentagesData.push([dateKey, 0]);
      }

      else {
        let positivePercentage = calculateCategoryPercentageRoundedToOneDecimalPlace(positiveCountsData[i][COUNT_INDEX], totalCount);
        let negativePercentage = calculateCategoryPercentageRoundedToOneDecimalPlace(negativeCountsData[i][COUNT_INDEX], totalCount);
        let neutralPercentage = calculateCategoryPercentageRoundedToOneDecimalPlace(neutralCountsData[i][COUNT_INDEX], totalCount);
        positivePercentagesData.push([dateKey, positivePercentage]);
        negativePercentagesData.push([dateKey, negativePercentage]);
        neutralPercentagesData.push([dateKey, neutralPercentage]);
      }
    }
    chartData[TOTAL_TREND_INDEX][DATA_KEY] = totalPercentagesData;
    chartData[POSITIVE_TREND_INDEX][DATA_KEY] = positivePercentagesData;
    chartData[NEGATIVE_TREND_INDEX][DATA_KEY] = negativePercentagesData;
    chartData[NEUTRAL_TREND_INDEX][DATA_KEY] = neutralPercentagesData;
    return chartData;
  }

  changeChartDataToPercentageForEmotionPercentageTrendCharts(chartData) {

    let joyPercentagesData = [];
    let fearPercentagesData = [];
    let sadnessPercentagesData = [];
    let angerPercentagesData = [];

    let joyCountsData = chartData[JOY_TREND_INDEX][DATA_KEY];
    let fearCountsData = chartData[FEAR_TREND_INDEX][DATA_KEY];
    let sadnessCountsData = chartData[SADNESS_TREND_INDEX][DATA_KEY];
    let angerCountsData = chartData[ANGER_TREND_INDEX][DATA_KEY];

    for (let i = 0; i < joyCountsData.length; i++) {
      let dateKey      = joyCountsData[i][DATE_KEY_INDEX];
      let joyCount     = joyCountsData[i][COUNT_INDEX];
      let fearCount    = fearCountsData[i][COUNT_INDEX];
      let sadnessCount = sadnessCountsData[i][COUNT_INDEX];
      let angerCount   = angerCountsData[i][COUNT_INDEX];
      let totalCount   = joyCount + fearCount + sadnessCount + angerCount;
      
      if (totalCount === 0) {
        joyPercentagesData.push([dateKey, 0]);
        fearPercentagesData.push([dateKey, 0]);
        sadnessPercentagesData.push([dateKey, 0]);
        angerPercentagesData.push([dateKey, 0]);
      }

      else {
        let joyPercentage     = calculateCategoryPercentageRoundedToOneDecimalPlace(joyCount, totalCount);
        let fearPercentage    = calculateCategoryPercentageRoundedToOneDecimalPlace(fearCount, totalCount);
        let sadnessPercentage = calculateCategoryPercentageRoundedToOneDecimalPlace(sadnessCount, totalCount);
        let angerPercentage   = calculateCategoryPercentageRoundedToOneDecimalPlace(angerCount, totalCount);
        joyPercentagesData.push([dateKey, joyPercentage]);
        fearPercentagesData.push([dateKey, fearPercentage]);
        sadnessPercentagesData.push([dateKey, sadnessPercentage]);
        angerPercentagesData.push([dateKey, angerPercentage]);
      }
    }
    chartData[JOY_TREND_INDEX][DATA_KEY] = joyPercentagesData;
    chartData[FEAR_TREND_INDEX][DATA_KEY] = fearPercentagesData;
    chartData[SADNESS_TREND_INDEX][DATA_KEY] = sadnessPercentagesData;
    chartData[ANGER_TREND_INDEX][DATA_KEY] = angerPercentagesData;
    return chartData;
  }

  findLabelTextOfPoint(x) {
    const labelItem = this.state.labelsData.find(item => item.x == x);
    if (labelItem)  {
      return labelItem.labelText;
    }
    else {
      return "";
    }
  }

  addALineAtXAxis(chart) {
    const that = this;
    if (chart[0]) {
      let line = JSON.parse(JSON.stringify(chart[0]))
      const name = '';
      line.category = name;
      line.categoryName = name;
      line.name = name;
      line.data = line.data.map(item => { return [item[0], 0] });
      line.showInLegend = false;
      line.color = '#ccd6eb';
      line.point = {
        events: {
          click: function (e) {
            that.showInputPopup(this.x, this.plotX, this.plotY, this.series.chart.plotLeft, this.series.chart.plotTop);
          },
          mouseOver() {
            let tooltip = this.series.chart.tooltip;
            tooltip.update(that.getXAxisToolTip());
          },
          mouseOut() {
            let tooltip = this.series.chart.tooltip;
            tooltip.update({
              ...DEFAULT_TOOLTIP
            });
          }
        }
      };
      line.marker = {
        enabled: false,
        symbol: 'circle',
        fillColor: '#536FA9'
      };
      chart.push(line);
    }
  }

  showInputPopup(timeStampOfLabel, plotX, plotY, plotLeft, plotTop) {
    const labelText = this.findLabelTextOfPoint(timeStampOfLabel);
    let popup = document.getElementById(this.state.addLabelPopupWrapperId);
    let popupContent = document.getElementById(this.state.addLabelPopupId);
    popup.style.left = plotX + plotLeft + POPUP_ADD_EVENT_LABEL_MARGIN_LEFT + 'px';
    popup.style.top = plotY + plotTop + POPUP_ADD_EVENT_LABEL_MARGIN_TOP + 'px';
    if (this.state.selectedDay === timeStampOfLabel || this.state.selectedDay === "") {
      popupContent.classList.toggle("show");
    }
    this.textAreaLabelRef.current.focus();
    this.setState({ selectedDay: timeStampOfLabel, textAreaValue: labelText });
  }

  getXAxisToolTip() {
    const that = this;
    return {
      useHTML: true,
      ...X_AXIS_LABEL_CUSTOM_TOOLTIP_STYLE,
      formatter: function () {
        const { point } = this;
        let text = ADD_EVENT_LABEL_TEXT;
        if (that.alreadyHasLabel(point)) {
          text = EDIT_EVENT_LABEL_TEXT;
        } 
        return `<div>
                  ${text}
                </div>`;
      }
    };
  }

  alreadyHasLabel(selectionPoint) {
    return this.state.labelsData.find(item => Number(item.x) === Number(selectionPoint.x));
  }

  setChartNewInfomationToState(chartData, mapOptions, source, annotations, labelsData,chartId) {
    this.setState({
      chartData,
      mapOptions,
      mapDataFromProps: this.props.Charts[chartId],
      mapLabelsFromProps: JSON.parse(JSON.stringify(this.props.Labels[chartId])),
      source,
      annotations,
      labelsData
    });
  }


  addInformationToChart(annotations, chartData, title, chartId) {
    let { mapOptions } = this.state;
    mapOptions[MAP_OPTIONS.annotations] = [...annotations];
    mapOptions[MAP_OPTIONS.series] = chartData.chart ? chartData.chart : [];
    mapOptions[MAP_OPTIONS.title][MAP_OPTIONS.text] = title;
    if (chartId === SENTIMENT_PERCENTAGE_TREND_CHART_ID || chartId === EMOTION_PERCENTAGE_TREND_CHART_ID) {
      mapOptions[MAP_OPTIONS.yAxis][MAP_OPTIONS.tickInterval] = PERCENTAGE_TREND_CHART_Y_AXIS_INTERVAL;
      mapOptions[MAP_OPTIONS.yAxis][MAP_OPTIONS.max] = PERCENTAGE_TREND_CHART_MAXIMUM_Y_AXIS_VALUE;
    }
    else {
      mapOptions[MAP_OPTIONS.yAxis][MAP_OPTIONS.tickInterval] = getYAxisTickInterval(chartData, AXIS_POINT_LIMIT);
      mapOptions[MAP_OPTIONS.yAxis][MAP_OPTIONS.max] = Math.max(...chartData.tickInterval);
    }
    return mapOptions;
  }

  convertDateTimeFormatInLabels(labelsFromBackend) {
    return labelsFromBackend.map(label => {
      return {
        ...label,
        x: moment.utc(label.dateTime).valueOf()
      };
    });
  }

  generateAnnotation(chart, labelData, hideSeries) {
    const that = this;
    if (labelData && this.state.isDisplayLabels) {
      const annotationData = this.generateAnnotationData(chart, hideSeries);
      let labelsToDisplay = this.getLabelsToDisplayInChart(chart, labelData);
      labelsToDisplay = this.addYMaxAndYForLabels(labelsToDisplay, annotationData);
      return labelsToDisplay.map((label) => {
        that.addALineAtAnnotation(chart, label);
        return {
          id: label.x,
          events: {
            click: function() {}
          },
          shapes: [
            {
              type: 'path',
              dashStyle: "Dash",
              strokeWidth: 1,
              stroke: "rgb(112, 112, 112)",
              points: [
                function () {
                  return {
                    x: label.x,
                    xAxis: 0,
                    y: label.yMax,
                    yAxis: 0
                  };
                },
                function (annotation) {
                  return {
                    x: label.x,
                    xAxis: 0,
                    y: 0,
                    yAxis: 0
                  };
                }
              ]
            }
          ],
          labels: [{
            useHTML: true,
            point: [{
              x: label.x,
              y: 0,
              xAxis: 0,
              yAxis: 0,
            }],
            style: {
              whiteSpace: "normal",
              marginBottom: "10px",
              color: "#666666",
              borderColor: "#707070"
            },
            backgroundColor: "#F6F6F6",
            formatter: function (e) {
              const point = this.target.points[0];
              const axesLen = this.series.chart.axes[0].len;
              const dataLen = chart[0].data.length;
              const plotLeft = this.series.chart.plotLeft;
              const plotTop = this.series.chart.plotTop;
              return that.getHTMLForLabel(label, point, axesLen, dataLen, plotLeft, plotTop);
            },
          }],
          labelOptions: {
            shape: 'connector',
            align: 'center',
            verticalAlign: "top",
            y: 45,
            allowOverlap: true,
            overflow: 'allow',
            borderColor: "#707070",
            style: {
              fontSize: `${this.state.labelsFontSize}px`,
            }
          },
        }
      })
    }
    return [];
  }

  generateYForLabel(label, annotations) {
    const timeStampOfLabel = label.x;
    try {
      if(this.props.chartType.includes(SPLINE_CHART)) {
        return this.generateYForCurveLine(annotations, timeStampOfLabel);
      }
      else {
        return this.generateYForStraightLine(annotations, timeStampOfLabel);
      }  
    } catch(ex) {
      const defaultY = [0];
      return defaultY;
    }
    
  }

  generateYForStraightLine(annotations, timeStampOfLabel) {
    const y = [];
    let indexOfLargerDate = 0;
      while(timeStampOfLabel > annotations[indexOfLargerDate].x) {
        indexOfLargerDate++;
    }
    const indexOfSmallerDate = indexOfLargerDate - 1;
    const xOfLargerDate = annotations[indexOfLargerDate].x;
    const yOfLargerDate = annotations[indexOfLargerDate].y;
    const xOfSmallerDate = annotations[indexOfSmallerDate].x;
    const yOfSmallerDate = annotations[indexOfSmallerDate].y; 
    for (let lineIndex = 0; lineIndex < annotations[0].y.length; lineIndex++) {
      let generatedY = 0;
      if(yOfLargerDate[lineIndex] === yOfSmallerDate[lineIndex]) {
        generatedY = yOfSmallerDate[lineIndex];
      } else {
        generatedY = (timeStampOfLabel - xOfSmallerDate) * 
        (yOfLargerDate[lineIndex] - yOfSmallerDate[lineIndex]) 
        / (xOfLargerDate - xOfSmallerDate) + yOfSmallerDate[lineIndex];
      }    
      y.push(Math.round(generatedY));
    }
    return y;
  }

  generateYForCurveLine(annotations, timeStampOfLabel) {
    const y = [];
    const degree = 1;
    for (let lineIndex = 0; lineIndex < annotations[0].y.length; lineIndex++) {
      const points = [];
      for (const annotation of annotations) {
        points.push([annotation.x, annotation.y[lineIndex]]);
      }
      const xMin = annotations[0].x;
      const xMax = annotations[annotations.length - 1].x;
      const point = bspline((timeStampOfLabel - xMin)/ (xMax - xMin), degree, points);
      const generatedY = point[1];
      y.push(generatedY);
    }
    return y;
  }

  addALineAtAnnotation(chart, label) {
    const x = label.x;
    const y = label.y;
    const id = label.id + MARKER_LINE;
    const lineIndex = chart.findIndex(item => item.id === id);
    let line = {};
    const name = "";
    line.category = MARKER_LINE;
    line.categoryName = id;
    line.id = id;
    line.name = name;
    line.data =  y ?  y.map(item => { return [x, item] }) : [];
    line.showInLegend = false;
    line.color = "none";
    line.marker = {
      enabled: true,
      symbol: 'circle',
      fillColor: '#FFFFFF',
      lineWidth: 1,
      lineColor: "#536FA9"
    };
    line.enableMouseTracking = false;
    if (lineIndex != -1) {
      chart[lineIndex] = line;
    }
    else {
      chart.push(line);
    } 
  }

  addYMaxAndYForLabels(labels, annotationData) {
    return labels.map((label) => {
      annotationData.forEach((item) => {
        if (item.x === label.x) {
          label.yMax = Math.max(...item.y);
          label.y = item.y;
        }
      });
      if(!label.y) {
        const generatedY = this.generateYForLabel(label, annotationData);
        label.y = [...generatedY];
        label.yMax = Math.max(...generatedY);
      }
      return label;
    })
  }

  getHTMLForLabel(label, point, axesLen, dataLen, plotLeft, plotTop) {
    return `<div id='${this.state.labelViewIdPrefix}${label.x}' onclick='${this.state.changeLabelZIndexFunctionName}(${label.x})' class="${EVENT_LABEL_WRAPPER_CLASS_NAME} ${this.state.eventLabelWrapperClassNameForChart}" style='position: relative;width:${9 / 10 * (axesLen / (dataLen - 1))}px'>
                <p class='${LABEL_TEXT_CLASS}'>${label.labelText}</p>
                <div class='annotation-action'>
                  <button class='${BUTTON_EDIT_LABEL_CLASSNAME}'  onclick='${this.state.showEditLabelFunctionName}(${label.x}, ${point.plotX}, ${point.plotY},  ${plotLeft}, ${plotTop})' />
                  <button class='${BUTTON_DELETE_LABEL_CLASSNAME}' onclick='${this.state.showDeleteViewFunctionName}(event, ${label.x})'/>
                </div>
              </div>`
  }


  generateAnnotationData(series, hideSeries) {
    const filteredSeries = this.filterSeries(series, hideSeries);
    return this.generateAnnotationFromSeries(filteredSeries);
  }

  filterSeries(series, hideSeries) {
    let filteredSeries = series;
    hideSeries.forEach(itemHide => {
      filteredSeries = filteredSeries.filter((item) => {
        return item.name !== itemHide
      })
    })
    filteredSeries = filteredSeries.filter((item) => {
      return item.showInLegend !== false;
    })
    return filteredSeries;
  }

  generateAnnotationFromSeries(series) {
    let annotationData = []
    if (series.length) {
      for (let i = 0; i < series[0][DATA_KEY].length; i++) {
        let y = [];
        let x = 0;
        series.forEach((arrayEmotion) => {
          y.push(arrayEmotion.data[i][1]);
          x = arrayEmotion.data[i][0];
        })
        annotationData.push({
          x,
          y
        });
      }
    }
    return annotationData;
  }


  _reflowChartIfCommentsSidebarHasOpenedOrClosed(nextProps) {
    if (nextProps.isCommentsActive !== this.state.isCommentsActive) {
      this.setState({
        isCommentsActive: nextProps.isCommentsActive
      }, () => {
        this._reflowChartAfterDelays();
      });
    }
  }

  handleTextAreaChange() {
    const inputTextarea = this.textAreaLabelRef.current.value;
    this.setState({
      textAreaValue: inputTextarea
    });
  };

  autoGrow(element) {
    if (element.scrollHeight > element.clientHeight) {
      element.style.height = (element.scrollHeight) + "px";
    }
  };

  renderAddLabelPopup() {
    return (
      <div className={ADD_LABEL_POPUP_WRAPPER_CLASS_NAME} id={this.state.addLabelPopupWrapperId}>
        <span className={ADD_LABEL_POPUP_CONTENT_CLASS} id={this.state.addLabelPopupId}>
          {this.renderAddLabelInput()}
          {this.renderAddLabelButtons()}
        </span>
      </div>
    );
  }

  getCharacterLeft() {
    return LABEL_INPUT_MAX_LENGTH - this.state.textAreaValue.length;
  };

  isAddNewLabel(timeStampOfLabel) {
    return !this.state.labelsData.find(label => label.x === timeStampOfLabel);
  }

  addOrUpdateLabels(timeStampOfLabel, labelDateTime, labelText) {
    const labels = [...this.state.labelsData];
    let item = labels.find(label => label.x === timeStampOfLabel);
    if (item) {
      item.labelText = labelText;
    }
    else {
      const newLabel = {
        x: timeStampOfLabel,
        labelText: labelText,
        dateTime: labelDateTime,
        topicId: this.props.selectedTopicId[0]
      };
      labels.push(newLabel);
    } 
    return labels;
  }

  isDeleteLabel(nextProps) {
    return nextProps.DeletedLabel[this.props.chartId] && nextProps.Labels[this.props.chartId] && this.state.mapLabelsFromProps && nextProps.Labels[this.props.chartId].length < this.state.mapLabelsFromProps.length;
  }

  updateLabelsOnUI(nextProps) {
    const that = this;
    const newLabelsData = this.convertDateTimeFormatInLabels(nextProps.Labels[this.props.chartId]);
    const annotations = this.generateAnnotation(this.state.chartData.chart, newLabelsData, this.state.hideSeries);
    let chart = this.state.chartData.chart;
    if(this.isDeleteLabel(nextProps)) {
      const idOfDeletedLabel = nextProps.DeletedLabel[this.props.chartId];
      if(this.chartComponent.current.chart && this.chartComponent.current.chart.get(idOfDeletedLabel + MARKER_LINE)) {
        this.chartComponent.current.chart.get(idOfDeletedLabel + MARKER_LINE).remove();
      }
      chart = this.state.chartData.chart.filter(item => item.id !== idOfDeletedLabel + MARKER_LINE);
    }
    this.setState(prevState => {
      return {
        ...prevState,
        chartData: {
          ...prevState.chartData,
          chart,
        },
        labelsData: newLabelsData,
        annotations,
        mapOptions: {
          ...prevState.mapOptions,
          series: chart,
          annotations,
        },
        mapLabelsFromProps: JSON.parse(JSON.stringify(nextProps.Labels[this.props.chartId]))
      }
    }, () => {
      if (that.state.isDisplayLabels) {
        that.showAllLabels();
      }
    });
  }

  handleSaveEventLabel() {
    const timeStampOfSelectedDay = this.state.selectedDay;
    const labelText = this.textAreaLabelRef.current.value;
    const labelDateTime =  moment.utc(timeStampOfSelectedDay).format(DATE_TIME_IN_YYYY_MM_DD_HH_MM_SS_FORMAT);
    this.hideAddEventLabelPopup();
    if(this.isAddNewLabel(timeStampOfSelectedDay)) {
      this.props.actions.createNewLabel({
        labelText,
        labelDateTime,
        topicId: this.state.topicId,
        chartId: this.props.chartId,
      });
    } else {
      this.editEventLabels(timeStampOfSelectedDay, labelText);
    }
  }

  editEventLabels(timeStampOfSelectedDay, labelText) {
    const labelDateTime =  moment.utc(timeStampOfSelectedDay).format(DATE_TIME_IN_YYYY_MM_DD_HH_MM_SS_FORMAT);
    const labelToEdit = this.props.Labels[this.props.chartId].find(label => label.dateTime === labelDateTime);
    if(labelToEdit) {
      this.props.actions.editEventLabel({
        id: labelToEdit.id,
        labelDateTime: labelToEdit.dateTime,
        newLabelText: labelText,
        chartId: this.props.chartId
      });
    }
  }

  renderAddLabelButtons() {
    return (
      <span className={ADD_LABEL_INPUT_ACTIONS_WRAPPER_CLASS_NAME}>
        <p>{this.getCharacterLeft()} character left</p>
        <p className={BUTTON_CANCEL_ADD_LABEL_CLASS_NAME} onClick={() => this.hideAddEventLabelPopup()}>Cancel</p>
        <p className={BUTTON_SAVE_LABEL_CLASS_NAME} onClick={() => this.handleSaveEventLabel()}>Save</p>
      </span>
    );
  }

  hideAddEventLabelPopup() {
    this.setState({ selectedDay: "", textAreaValue: "" });
    const popupContent = document.getElementById(this.state.addLabelPopupId);
    if(popupContent.classList.contains("show")) {
      popupContent.classList.remove("show");
    }
  };

  renderAddLabelInput() {
    return (
      <textarea
        className={LABEL_INPUT_CLASS_NAME}
        maxLength={LABEL_INPUT_MAX_LENGTH}
        rows={5}
        style={{ resize: "none" }}
        ref={this.textAreaLabelRef}
        onChange={this.handleTextAreaChange}
        onInput={() => this.autoGrow(this.textAreaLabelRef.current)}
        value={this.state.textAreaValue}
      ></textarea>
    );
  }

  render() {
    const { mapOptions } = this.state;
    this.updateChartHeightAndMarginBottom();
    return (
      <React.Fragment>
        {mapOptions[SERIES_KEY] && mapOptions[SERIES_KEY].length > 0 ? (
          <HighchartsReact
            highcharts={Highcharts}
            options={mapOptions}
            allowChartUpdate={true}
            immutable={false}
            updateArgs={[true, true, true]}
            ref={this.chartComponent}
          />
        ) : (
          <HighchartsReact highcharts={Highcharts} options={mapOptions} ref={this.chartComponent} />
        )}
        {this.renderAddLabelPopup()}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    Charts: state.charts,
    Labels: state.charts.labels,
    DeletedLabel: state.charts.deletedLabel
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EventLabellingChart);



// WEBPACK FOOTER //
// ./src/features/shared-components/chart/EventLabellingChart.js